import React from 'react';
import styled, { css } from 'styled-components';

import { ContentContainerSmall } from '@/components/ContentContainer';
import { useTypedSelector } from '@/store/store';
import {
  selectDealer,
  selectDealerReviews,
} from '@/store/reducers/single-dealer';
import { colors } from '@/constants/theme';
import { media } from '@/utils/mixin';
import Rating from '@/components/Rating';
import DealerReviews from '@/components/DealerReviews';

function Reviews() {
  const reviews = useTypedSelector(selectDealerReviews);
  const dealer = useTypedSelector(selectDealer);

  if (!reviews || !reviews.data || reviews.data.length === 0 || !dealer) {
    return null;
  }

  return (
    <Component id="reviews">
      <ContentContainerSmall>
        <Header>
          <Title>Отзывы</Title>
          <Stat>
            <Rating count={5} value={dealer.rating ?? 0} />
            <ReviewCount>{dealer.reviewsCount} отзывов</ReviewCount>
          </Stat>
        </Header>

        <DealerReviewsWrapper>
          <DealerReviews dealerId={dealer.id} />
        </DealerReviewsWrapper>
      </ContentContainerSmall>
    </Component>
  );
}

export default Reviews;

const Component = styled.section`
  padding: 20px 0 40px;

  ${ContentContainerSmall} {
    ${media.tablet(css`
      padding: 0 20px;
    `)}
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;

  ${media.mobile(css`
    flex-direction: column;
    align-items: flex-start;
  `)}
`;

const Title = styled.span`
  font-weight: 700;
  font-size: 40px;
  line-height: 52px;
  color: ${(props) => props.theme.black};

  ${media.tablet(css`
    font-size: 26px;
    line-height: 34px;
  `)}
`;

const Stat = styled.div`
  display: flex;
  align-items: center;
  margin-left: 20px;

  ${media.mobile(css`
    margin-top: 5px;
    margin-left: 0;
  `)}
`;

const ReviewCount = styled.span`
  font-size: 14px;
  line-height: 24px;
  margin-left: 10px;
  color: ${colors.gray};
`;

const DealerReviewsWrapper = styled.div`
  margin-top: 20px;
`;
